import { FloatingOverlay } from '@floating-ui/react-dom-interactions'
import Styles from 'common/Prose/nodeViews/Image/Image.module.scss'
import { ActionImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ActionImageVariant'
import React from 'react'
import { useImageStore } from 'stores/ImageStore'
import { useReactNodeView } from 'common/Prose/nodeViews/ReactNodeView/ReactNodeViewContext'
import { ImageNodeAttrs } from 'common/Prose/nodeViews/Image/Types'
import { observer } from 'mobx-react-lite'

export const ImageVariantContainer = observer(() => {
  const imageStore = useImageStore()
  const { view, node } = useReactNodeView()

  if (!imageStore.lastVariant) return null

  return (
    <div style={{ zIndex: 2 }}>
      <FloatingOverlay onClick={imageStore.clearVariants} />
      <div className={Styles.revisedImageContainer}>
        <ActionImageVariant variant={imageStore.lastVariant} attrs={node.attrs as ImageNodeAttrs} view={view} />
      </div>
    </div>
  )
})
